import React, { useEffect, useRef, useState } from "react";
import { Fullscript } from "@fullscript/fullscript-js";
import useQuery from "../Register/useQuery";
import { getUserDetail } from "../../utils/helper";
import { useDispatch } from "react-redux";
import {
  getFullscriptTreamtmentplanList,
  profilePostAction,
} from "../../actions/profileAction";
import { practitonerPrescriptionPostAction } from "../../actions/prescriptionAction";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import {
  Fullscript_Public_key,
  Fullscript_OAuth_Url,
  Fullscript_Env,
} from "../../constants/states";
const FullscriptPage = ({
  patientFirstName,
  patientLastName,
  patientEmail,
  patientPhone,
  fullscriptId,
  setFullscriptId,
  ppcId,
}) => {
  var fullscriptClient = Fullscript({
    publicKey: Fullscript_Public_key,
    env: Fullscript_Env,
  });

  const [isBusy, setIsBusy] = useState(false);
  let query = useQuery();
  let oauthToken = query.get("code");
  const mounted = useRef(false);
  var treatmentPlanFeature;
  const dispatch = useDispatch();
  const [secretToken, setSecretToken] = useState(null);

  const getSecretToken = () => {
    var params = {
      params: {
        action: "getSecretToken",
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, (secret_token) => {
        setIsBusy(false);

        if (secret_token) {
          setSecretToken(secret_token);
        } else {
          window.location.href = Fullscript_OAuth_Url;
        }
      })
    );
  };

  const handlePatientSelected = (payload) => {
    if (!fullscriptId) {
      setFullscriptId(payload.data.patient.id);
    }
    const data = {
      action: "saveFullscriptId",
      fullscript_id: payload.data.patient.id,
      ppc_id: ppcId,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(
      practitonerPrescriptionPostAction(params, () => {
        dispatch(getCreatePrescriptionPatients());
      })
    );
  };

  const handleTreatmentPlanActivated = (payload) => {
    var params = {
      params: {
        action: "getTreatmentplanList",
        token: getUserDetail()?.token,
        data: { fullscript_id: payload.data.treatmentPlan.patient.id },
      },
    };
    dispatch(getFullscriptTreamtmentplanList(params));
  };

  const getAccessToken = () => {
    if (isBusy) return;
    setIsBusy(true);
    if (oauthToken) {
      var params = {
        params: {
          action: "getAccessToken",
          data: { oauthToken: oauthToken },
          token: getUserDetail()?.token,
        },
      };
    }

    dispatch(
      profilePostAction(params, (secret_token) => {
        if (secret_token) {
          setSecretToken(secret_token);
        } else {
          window.location.href = Fullscript_OAuth_Url;
        }
      })
    );
  };

  useEffect(() => {
    if (!oauthToken) {
      getSecretToken();
    }
  }, []);

  useEffect(() => {
    if (mounted.current) {
      treatmentPlanFeature?.unmount("treatment-plan-container");
      mounted.current = false;
    }
  }, [fullscriptId]);

  const mountTreatmentPlan = (secretToken) => {
    treatmentPlanFeature = fullscriptClient.create("treatmentPlan", {
      secretToken: secretToken,
      patient: {
        id: fullscriptId,
        firstName: patientFirstName,
        lastName: patientLastName,
        email: patientEmail,
        mobileNumber: "+1" + patientPhone,
      },
    });
    treatmentPlanFeature.mount("treatment-plan-container");
    mounted.current = true;
    treatmentPlanFeature.on(
      "treatmentPlan.activated",
      handleTreatmentPlanActivated
    );
    treatmentPlanFeature.on("patient.selected", handlePatientSelected);
  };

  useEffect(() => {
    if (secretToken) {
      mountTreatmentPlan(secretToken);
    } else if (oauthToken) {
      getAccessToken();
    }
    return () => {
      if (mounted.current) {
        treatmentPlanFeature?.unmount("treatment-plan-container");
        mounted.current = false;
      }
    };
  }, [secretToken]);

  return (
    <div className="fullscript-wrapper" id="treatment-plan-container"></div>
  );
};
export default FullscriptPage;
